import { render, staticRenderFns } from "./modalColores.vue?vue&type=template&id=13635c82&scoped=true&"
import script from "./modalColores.vue?vue&type=script&lang=js&"
export * from "./modalColores.vue?vue&type=script&lang=js&"
import style0 from "./modalColores.vue?vue&type=style&index=0&id=13635c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13635c82",
  null
  
)

export default component.exports